import productLabelPdf from 'assets/static/product_label.pdf'
import { useTranslation } from 'react-i18next'

const ProductLabelPage = () => {
    const { t } = useTranslation('pages')

    return (
        <div
            style={{
                width: '100%',
                height: 'calc(100vh - 120px)',
                padding: '16px'
            }}
        >
            <iframe
                src={productLabelPdf}
                title={t('productLabel.title')}
                width="100%"
                height="100%"
                style={{ border: 'none' }}
            />
        </div>
    )
}

export default ProductLabelPage
